import createEndpoint, { createTanstackEndpoint } from "../utils/create-endpoint"
import { endpoints } from "./endpoints"

const endpoint = endpoints.system.listItems

export default createEndpoint(endpoint, "GET")

export const getListItemsTanstack = createTanstackEndpoint(endpoint, "GET")
